import React from 'react';

const FullscreenOverlay = ({ isOpen, onClose, children }) => {
    return (
        isOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white p-8 rounded shadow-lg w-full max-w-md mx-auto">
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
                    >
                        ✕
                    </button>
                    {children}
                </div>
            </div>
        )
    );
};

export default FullscreenOverlay;